var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, html, css } from "lit";
import { customElement, property } from "lit/decorators.js";
let BasicNote = class BasicNote extends LitElement {
    constructor() {
        super(...arguments);
        this.variant = 'primary';
        this.size = 'medium';
    }
    updated(changedProps) {
        super.updated(changedProps);
        this.updateHostClasses();
    }
    updateHostClasses() {
        const host = this;
        const classes = [
            this.variant || 'primary',
            this.size || 'medium',
        ].filter(Boolean).join(' ');
        host.className = classes;
    }
    render() {
        return html `<slot></slot>`;
    }
};
BasicNote.styles = css `
    :host{
      font-size: 0.85rem;
      color: #7f8c8d;
      margin-top: 12px;
      background: #f0f0f0;
      border-left: 3px solid #ccc;
      border-radius: 4px;
      font-style: italic;
      padding: 10px 12px;
      transition: all 0.2s;
    }
    /* Variants */
    :host(.primary) {
      border-left-color: #0078d4;
      background: #eaf6ff;
      color: #005a9e;
    }
    :host(.secondary) {
      border-left-color: #ccc;
      background: #f0f0f0;
      color: #333;
    }
    :host(.success) {
      border-left-color: #28a745;
      background: #e6f9ec;
      color: #218838;
    }
    :host(.danger) {
      border-left-color: #dc3545;
      background: #fbeaea;
      color: #c82333;
    }
    :host(.warning) {
      border-left-color: #ffc107;
      background: #fffbe6;
      color: #e0a800;
    }

    /* Sizes */
    :host(.small) {
      font-size: 0.75rem;
      padding: 4px 8px;
      border-radius: 2px;
      border-left-width: 2px;
    }
    :host(.medium) {
      font-size: 0.85rem;
      padding: 10px 12px;
      border-radius: 4px;
      border-left-width: 3px;
    }
    :host(.large) {
      font-size: 1.1rem;
      padding: 18px 24px;
      border-radius: 8px;
      border-left-width: 5px;
    }
    `;
__decorate([
    property({ type: String })
], BasicNote.prototype, "variant", void 0);
__decorate([
    property({ type: String })
], BasicNote.prototype, "size", void 0);
BasicNote = __decorate([
    customElement("basic-note")
], BasicNote);
export { BasicNote };
//# sourceMappingURL=BasicNote.js.map